import React, { useEffect, useState } from "react";
import CartDrawer from "../AdminComponents/CartDrawer";
import DrawerTitle from "./DrawerTitle";
import LoginCustomer from "../AllTabs/LoginCustomer";
import AccountTab from "../AllTabs/AccountTab";
import { AllTabType, IAddressData } from "src/types/GlobalInterfaces";
import MyOrdersScreen from "../AllTabs/MyOrdersScreen";
import MyActivityScreen from "../AllTabs/MyActivityScreen";
import MyResultsScreen from "../AllTabs/MyResultsScreen";
import MyAppointmentScreen from "../AllTabs/MyAppointmentScreen";
import MyDoctorsScreen from "../AllTabs/MyDoctorsScreen";
import ManageDoctorScreen from "../AllTabs/ManageDoctorScreen";
import NotificationScreen from "../AllTabs/NotificationScreen";
import ManageNotificationsScreen from "../AllTabs/ManageNotificationsScreen";
import ManageAddressScreen from "../AllTabs/ManageAddressScreen";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import ManageCartScreen from "../AllTabs/ManageCartScreen";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  tab?: AllTabType;
  className?: string;
  onSelectAddress?: (address: IAddressData | null) => void;
}

const ManageCartDrawer: React.FC<IProps> = ({
  isOpen,
  onClose,
  tab,
  className,
  onSelectAddress,
}) => {
  const [activeTab, setActiveTab] = useState<AllTabType>("ManageCart");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setActiveTab(tab || "ManageCart");
    setIsModalOpen(false);
  }, [tab, isOpen]);

  return (
    <CartDrawer
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      showModal={isModalOpen}
      modalContent={{
        title: "Thank You!",
        description: `Your Order Has Been Successfully Placed.`,
      }}
    >
      {/* {isOpen && ( */}
        <ManageCartScreen
          onBack={onClose}
          setActiveTab={setActiveTab}
          isOpen={isOpen}
          onSuccess={() => {
            console.log("onSuccess Called");
            
            setIsModalOpen(true);
          }}
        />
      {/* )} */}
    </CartDrawer>
  );
};

export default ManageCartDrawer;
